module.exports = __webpack_public_path__ + "media/31.712c7bd9.mp3";